export const apiConstants = {
  PlatformType: "WEBSITE",
  // Razorpay checkout key. Shared by the wallet recharge page and the
  // order payment popup so a key rotation only has to happen in one place.
  RazorpayKey: "rzp_live_F4irUoIZIjoCw2",
  RazorpayTestKey: "rzp_test_8i8V9mMoWeq04q",
  WalletGstPercent: 18
};
